import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Shared axios instance for the admin area — attaches Bearer token and
// redirects to /admin/login on 401 responses.
export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("admin_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            localStorage.removeItem("admin_token");
            if (
                typeof window !== "undefined" &&
                window.location.pathname.startsWith("/admin") &&
                window.location.pathname !== "/admin/login"
            ) {
                window.location.href = "/admin/login";
            }
        }
        return Promise.reject(err);
    }
);

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Something went wrong.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" · ");
    }
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
